<div *ngIf="data" [innerHTML]="data"></div>